import React from 'react'
import { GeneralLedgerPolicyForm } from './GeneralLedgerPolicyForm'

const generalLedgerPolicyRoutes = [
  {
    props: {
      exact: true,
      path: '/general-ledger/general-setting/general-ledger-policy',
    },
    component: <GeneralLedgerPolicyForm />,
  },
]

export default generalLedgerPolicyRoutes
